import DefaultProps from '../../commonTypes/defaultprops.types';

export enum TemplateTypes {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  INFO = 'info',
}

export interface TemplateProps extends DefaultProps {
  headline: string;
  type: TemplateTypes;
}
